export class Pricing {
  constructor(pricing) {
    this.pricing = pricing;
    this.priceInput = this.pricing.querySelector("input[name='price']");
    this.usersInput = this.pricing.querySelector("input[name='users']");

    this.maxed = this.pricing.querySelector("[data-maxed-out]");
    this.price = this.pricing.querySelector("[data-price]");
    this.users = this.pricing.querySelector("[data-users]");

    this.usersInput.addEventListener("input", () => {
      this.updatePrice();
      this.updateUI();
    });

    this.updatePrice();
    this.updateUI();
  }

  updatePrice() {
    const priceRanges = [
      { usersUpTo: 50, price: 4.5 },
      { usersUpTo: 100, price: 3.5 },
      { usersUpTo: 501, price: 2.5 },
    ];

    const usersNumber = this.usersInput.value;

    let price = this.getPriceForUserGroup(priceRanges, usersNumber);
    this.priceInput.value =
      price.toString().includes(".") || price.toString().includes(",")
        ? price + "0"
        : price;
  }

  getPriceForUserGroup(priceRanges, usersNumber) {
    // For the given usersNumber, return the global price by applying the price assigned per user for every price range
    // Example: usersNumber = 101, priceRanges = [{ usersUpTo: 50, price: 4 }, { usersUpTo: 100, price: 3 }, { usersUpTo: 500, price: 2 }]
    // The function will return 50 * 4 + 50 * 3 + 2 * 1 = 352

    let price = 0;

    for (let i = 0; i < usersNumber; i++) {
      for (let j = 0; j < priceRanges.length; j++) {
        if (i < priceRanges[j].usersUpTo) {
          price += priceRanges[j].price;
          break;
        }
      }
    }

    return price;
  }

  updateUI() {
    this.maxed.setAttribute(
      "data-maxed-out",
      parseInt(this.usersInput.value) >=
        parseInt(this.usersInput.getAttribute("max"))
    );
    this.price.textContent = this.priceInput.value;
    this.users.textContent = this.usersInput.value;
  }
}
